import React from "react";
import "./TagPill.scss"

class TagPill extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    const {nameSpace, label, isDeleted} = this.props;
    return (
      <div className="tag-pill link-pill">
        <div className="n_space"> {nameSpace} </div>
        <div className="label"> {label} </div>
        {isDeleted ? <span className="deleted-mark">!</span> : null}
      </div>
    );
  }
}

export default TagPill;
